import { defineComponent as v, ref as f, computed as C, createBlock as n, openBlock as o, unref as t, withCtx as s, createElementVNode as d, normalizeClass as i, createVNode as u, createTextVNode as _, toDisplayString as c, normalizeStyle as b, Teleport as h, createElementBlock as y, createCommentVNode as L, Fragment as N, renderList as B } from "vue";
import { useFloating as S, offset as E, flip as R, shift as x, autoUpdate as z } from "@floating-ui/vue";
import { Listbox as D, ListboxButton as F, ListboxOptions as O, ListboxOption as T } from "@headlessui/vue";
import { ScalarIconCaretDown as U } from "@scalar/icons";
const W = { class: "option-label" }, q = /* @__PURE__ */ v({
  __name: "HeaderListbox",
  props: {
    options: {},
    modelValue: {},
    static: { type: Boolean },
    buttonName: {},
    buttonClass: {}
  },
  emits: ["update:modelValue"],
  setup($) {
    const p = f(null), r = f(null), V = C(
      () => r.value?.children?.[0] || r.value
    ), { floatingStyles: g } = S(V, p, {
      placement: "bottom-start",
      whileElementsMounted: z,
      middleware: [E(5), R(), x()]
    });
    return (e, m) => (o(), n(t(D), {
      as: "div",
      modelValue: e.modelValue,
      "onUpdate:modelValue": m[0] || (m[0] = (a) => e.$emit("update:modelValue", a))
    }, {
      default: s(({ open: a }) => [
        d("div", {
          ref_key: "buttonWrapper",
          ref: r,
          class: i({
            "button-wrapper": !!e.$slots.default
          })
        }, [
          u(t(F), {
            as: "button",
            class: i(["header-item-link header-group-link", e.buttonClass])
          }, {
            default: s(() => [
              _(c(e.buttonName) + " ", 1),
              u(t(U), {
                style: b({
                  transform: a ? "rotate(180deg)" : "rotate(0deg)"
                })
              }, null, 8, ["style"])
            ]),
            _: 2
          }, 1032, ["class"])
        ], 2),
        (o(), n(h, {
          disabled: e.static,
          to: "#app"
        }, [
          a ? (o(), y("div", {
            key: 0,
            ref_key: "dropdownRef",
            ref: p,
            class: "floating",
            style: b(t(g))
          }, [
            u(t(O), {
              class: "dropdown",
              static: ""
            }, {
              default: s(() => [
                (o(!0), y(N, null, B(e.options, (l) => (o(), n(t(T), {
                  key: l.id,
                  as: "template",
                  disabled: l.disabled,
                  value: l
                }, {
                  default: s(({ active: k, selected: w }) => [
                    d("li", {
                      class: i(["option", { active: k, selected: w }])
                    }, [
                      d("span", W, c(l.label), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["disabled", "value"]))), 128))
              ]),
              _: 1
            })
          ], 4)) : L("", !0)
        ], 8, ["disabled"]))
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
});
export {
  q as default
};
